import { render } from "./BTab.vue?vue&type=template&id=7d99329d"
import script from "./BTab.vue?vue&type=script&lang=js"
export * from "./BTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__